module.exports = __webpack_public_path__ + "static/media/img6.efd9aad4.jpg";